import { createSafeContext } from "utils/createSafeContext";

export const [SidebarContext, useSidebarContext] = createSafeContext(
    "useSidebarContext must be used within SidebarProvider"
);

export const initialState = {
  isExpanded: false,
  setIsExpanded: () => {},
  isHovered: false,
  setHovered: () => {},
  isPinned: false,
  setPinned: () => {},
};

